angular
	.module 'App.Module.CustomerGroup', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'customer_groups',
				url: '/customer_groups',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@customer_groups':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Users.Customers'
					searchParams:
						repositoryName: 'CustomerGroupRepository'
						title: 'general.customer.group'

			.state 'customer_groups.edit',
				url: '/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					customerGroup: (CustomerGroupRepository, $stateParams) ->
						return CustomerGroupRepository.getEntity $stateParams.id

			.state 'customer_groups.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'CustomerGroupController'
						controllerAs: 'vm'
						templateUrl: '@app/customer-group/customer-group.view.html'
